import loadScriptService from "../../_services/loadScriptService";

var intercomSettings = {
    app_id: 'wx5uw9ya' // Value replaced during build
};

if (window.tbg.user) {
    intercomSettings.name = window.tbg.user.name;
    intercomSettings.email = window.tbg.user.email;
}

var i = function () {
    i.c(arguments);
};

i.q = [];

i.c = function (args) {
    i.q.push(args);
};

window.Intercom = i;

loadScriptService({
    url: 'https://widget.intercom.io/widget/wx5uw9ya', // Value replaced during build
    delay: 5000,
    callback: function () {
        window.Intercom('reattach_activator');
        window.Intercom('update', intercomSettings);
    }
});